namespace TabAurous.ECommerce {
    export interface ECommSalesItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        Hallmark: Serenity.LookupEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        OrderAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        DiscountPer: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        DepartmentId: Serenity.IntegerEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: ECommSalesItemsBOMEditor;
        LaborDetails: ECommSalesLaborEditor;
    }

    export class ECommSalesItemsForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommSalesItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommSalesItemsForm.init)  {
                ECommSalesItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonProductSizeLookup;
                var w5 = s.BooleanEditor;
                var w6 = s.DecimalEditor;
                var w7 = WeightEditor;
                var w8 = StoneSieveLookup;
                var w9 = s.DateEditor;
                var w10 = s.ImageUploadEditor;
                var w11 = ECommSalesItemsBOMEditor;
                var w12 = ECommSalesLaborEditor;

                Q.initFormType(ECommSalesItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'ProductTypeId', w2,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'SubCategoryId', w2,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'ProductSizeId', w4,
                    'HasBom', w5,
                    'MetalId', w2,
                    'Attribute', w0,
                    'KaratId', w2,
                    'Purity', w6,
                    'PureWeight', w7,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w8,
                    'GroupSieveId', w8,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'Hallmark', w2,
                    'CalcOnId', w2,
                    'CalcUnitId', w2,
                    'Pieces', w1,
                    'Weight', w7,
                    'UnitRate', w6,
                    'UnitLabour', w6,
                    'NetAmount', w6,
                    'GrossAmount', w6,
                    'OrderAmount', w6,
                    'Line_No', w0,
                    'HSN', w2,
                    'TaxCode', w2,
                    'NetWeight', w7,
                    'DiamondPieces', w1,
                    'DiamondWeight', w7,
                    'StonePieces', w1,
                    'StoneWeight', w7,
                    'OtherPieces', w1,
                    'OtherWeight', w7,
                    'MetalAmount', w6,
                    'DiamondAmount', w6,
                    'StoneAmount', w6,
                    'OtherAmount', w6,
                    'UnitCost', w6,
                    'DiscountPer', w6,
                    'Discount', w6,
                    'WstPer', w6,
                    'WstWt', w7,
                    'DepartmentId', w1,
                    'IsDisabled', w5,
                    'ServerDate', w9,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w9,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'ImageName', w10,
                    'BOMDetails', w11,
                    'LaborDetails', w12
                ]);
            }
        }
    }
}
